import React from "react";
import logo from "./hublot-logo-upd.svg";
import "./global_nav.css";
import "./algolia.css";
import "../../css/index.scss";

const Navigation = () => {
    return (
        <header
            data-name="Navigation"
            className="nav_bar__container js_nav_bar_container nav_bar__container--algolia js-ais-nav-bar"
            role="banner"
        >
            <div
                className="js_sticky sticky sticky--smooth nav_bar_sticky"
                data-sticky-hide-onscroll-up="true"
                data-bp="1024px"
            >
                <div
                    className="nav_bar js_global_nav"
                    data-bp="1024px"
                    data-current-section="watches"
                >
                    <div className="nav_bar__content">
                        <div className="nav_bar__hamburguer">
                            <button
                                type="button"
                                aria-label="Open menu"
                                data-aria-label-close="Close menu"
                                data-aria-label-open="Open menu"
                                className="hamburger hamburger--spin js_hamburguer"
                            >
                                <span
                                    className="hamburger-box"
                                    aria-hidden="true"
                                >
                                    <span className="hamburger-inner"></span>
                                </span>
                            </button>
                        </div>

                        <div className="nav_bar__logo">
                            <a
                                href="/en-us"
                                title="Go to homepage"
                                className="nav_bar__logo_link"
                            >
                                <img
                                    src={logo}
                                    alt="Hublot logo"
                                    className="logo lazyloaded"
                                ></img>
                            </a>
                        </div>

                        <div className="nav_bar__icons">
                            <div className="nav_bar__icon_wrapper">
                                <a
                                    className="nav_bar__anchor nav_bar__anchor--mobile"
                                    href="https://boutique.hublot.com/checkout/cart/"
                                    data-template="Shopping cart, @products products"
                                    aria-label="Shopping cart, 0 products"
                                    target="_blank"
                                >
                                    <span
                                        className="icon icon-cart"
                                        aria-hidden="true"
                                    ></span>
                                </a>
                            </div>

                            <div className="nav_bar__icon_wrapper js_hublotista_logout">
                                <a
                                    href="https://www.hublot.com/your-hublot"
                                    className="js_secondary_link nav_bar__anchor nav_bar__anchor--mobile hublotista_link"
                                    rel="noopener"
                                    target="_self"
                                    aria-label="0"
                                >
                                    <span className="icon icon-user"></span>
                                </a>
                            </div>
                        </div>
                        <div className="nav_bar__navigation js_menu">
                            <nav
                                className="nav_bar__main_nav"
                                aria-label="Main"
                            >
                                <a
                                    href="/en-us/watches"
                                    className="nav_bar__main_link js_primary_link nav_bar__main_link--current-section"
                                    id="watches"
                                    data-drupal-link-system-path="node/84"
                                    aria-label="Watches"
                                    aria-current="page"
                                >
                                    Watches
                                </a>
                                <a
                                    href="/en-us/our-world"
                                    className="nav_bar__main_link js_primary_link"
                                    id="our_world"
                                    data-drupal-link-system-path="node/18"
                                    aria-label="Our world"
                                >
                                    Our world
                                </a>
                                <a
                                    href="/en-us/boutiques"
                                    className="nav_bar__main_link js_primary_link"
                                    id="boutiques"
                                    data-drupal-link-system-path="node/2308"
                                    aria-label="Boutiques"
                                >
                                    Boutiques
                                </a>
                            </nav>

                            <div className="nav_bar__icons">
                                <div className="nav_bar__icon_wrapper">
                                    <button
                                        type="button"
                                        className="wl_button js_view_wishlist wl_button__icon nav_bar__button"
                                        aria-label="Open your wishlist"
                                        data-starting-point="wishlist"
                                    >
                                        <span
                                            className="wl_button__icon icon-wishlist"
                                            aria-hidden="true"
                                        ></span>
                                    </button>
                                </div>
                                <div className="nav_bar__icon_wrapper">
                                    <button
                                        type="button"
                                        className="nav_bar__button nav_bar__button--search ais-trigger js-ais-trigger"
                                        aria-label="Search in this site"
                                    >
                                        <span
                                            className="icon-search"
                                            aria-hidden="true"
                                        ></span>
                                    </button>
                                </div>
                                <div className="nav_bar__icon_wrapper">
                                    <a
                                        className="nav_bar__anchor"
                                        href="https://boutique.hublot.com/checkout/cart/"
                                        data-template="Shopping cart, @products products"
                                        aria-label="Shopping cart, 0 products"
                                        target="_blank"
                                    >
                                        <span
                                            className="icon icon-cart"
                                            aria-hidden="true"
                                        ></span>
                                    </a>
                                </div>
                            </div>
                            <div className="hublotista">
                                <nav className="nav_bar__secondary_nav">
                                    <button
                                        className="nav_bar__secondary_link js_secondary_link js_view_wishlist js_view_wishlist__always_active"
                                        data-starting-point="wishlist"
                                    >
                                        wishlist
                                        <span
                                            className="icon icon-wishlist"
                                            aria-label="Open your wishlist"
                                        ></span>
                                    </button>

                                    <a
                                        href="https://account.hublot.com"
                                        className="nav_bar__secondary_link js_secondary_link hublotista_link hublotista_desktop"
                                        rel="noopener"
                                        target="_self"
                                    >
                                        HUBLOTISTA
                                        <span className="icon icon-user"></span>
                                    </a>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ais-search-box js-ais-search-box ">
                    <form
                        action=""
                        role="search"
                        className="ais-search-box__form js-ais-search-box__form"
                        noValidate={false}
                    >
                        {/* <input class="ais-search-box__input js-ais-search-box__input" type="search" placeholder="What are you looking for?" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" maxlength="512"> */}

                        <button
                            className="ais-search-box__reset js-ais-search-box__reset"
                            type="reset"
                            title="Clear the search query."
                        >
                            Reset
                        </button>

                        <button
                            className="ais-search-box__button-close js-ais-search-box__button-close"
                            type="reset"
                            aria-label="Close this modal"
                        >
                            <span
                                className="icon-close"
                                aria-hidden="true"
                            ></span>
                        </button>
                    </form>
                    <span className="icon-search"></span>
                </div>
            </div>
        </header>
    );
};

export default Navigation;
